export default "__VITE_ASSET__DR1uGTd5__"